import { createApp, h } from 'vue';
import { createInertiaApp, Link, usePage } from '@inertiajs/vue3';
import AppTitle from './site/base/AppTitle.vue';

window._ = require('lodash');
window.axios = require('axios');

createInertiaApp({
    // eslint-disable-next-line import/no-dynamic-require
    resolve: name => require(`./site/pages/${name}`),
    setup({
        el, App, props, plugin
    }) {
        // Remove server rendered title.
        document.querySelector('title').remove();

        createApp({ render: () => h(App, props) })
            .use(plugin)
            .component('InertiaLink', Link)
            .component('AppTitle', AppTitle)
            .mixin({
                computed: {
                    hasComicNavbar() {
                        return usePage().props.routeName === 'comic'
                            || usePage().props.routeName === 'comic_gallery';
                    }
                },

                methods: {
                    route: window.route,

                    timer(value) {
                        const abs = Math.abs(value);

                        let segments = [
                            (abs % 3600) / 60,
                            abs % 60
                        ];

                        segments = _.map(
                            segments, segment => _.padStart(Math.floor(segment), 2, '0')
                        );

                        const [
                            minutes, seconds
                        ] = segments;

                        return `${minutes}:${seconds}`;
                    }
                }
            })
            .mount(el);
    }
});
